import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import RouteList from 'routes';
import "react-datetime/css/react-datetime.css";

function App() {
  return (
    <Router>
      <RouteList />
    </Router>
  );
}

export default App;
